// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__hviXf","text":"styles_text__ByTfv"};